module.exports = __webpack_public_path__ + "static/img/6-3.43e22029.png";